import pkg from "../../package.json";

const sourceCode = {
  displayName: "Truth Web",
  version: pkg.version,
  homepage: pkg.homepage,
};

export default sourceCode;
